export function delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function fetchWithTimeout(url: string | URL, { timeout, ...options }: RequestInit & { timeout?: number } = {}) {
  const controller = new AbortController();
  let timeoutId: ReturnType<typeof setTimeout>;

  const fetchPromise = fetch(url, { ...options, signal: controller.signal }).finally(() => {
    clearTimeout(timeoutId);
  });

  const promises: Promise<Response>[] = [fetchPromise];

  if (timeout) {
    const timeoutPromise = new Promise<never>((_, reject) => {
      timeoutId = setTimeout(() => {
        controller.abort();
        reject(new Error('Request timed out'));
      }, timeout);
    });

    promises.push(timeoutPromise);
  }

  return Promise.race(promises);
}

export function allSettled<T extends readonly unknown[] | readonly [unknown]>(
  values: T,
): Promise<{ -readonly [P in keyof T]: PromiseSettledResult<T[P] extends PromiseLike<infer U> ? U : T[P]> }> {
  const wrappedPromises = values.map(p =>
    Promise.resolve(p).then(
      val => ({ status: 'fulfilled' as const, value: val }),
      err => ({ status: 'rejected' as const, reason: err }),
    ),
  );

  return Promise.all(wrappedPromises) as any;
}

export function notNull<T>(item: T | undefined | null): item is T {
  return !!item;
}

export function isString(value: unknown): value is string {
  return typeof value === 'string';
}

export function isObject(value: unknown): value is object {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function noop(..._args: any[]) {}
